import CustomisableFooter from '@rsa-digital/evo-shared-components/components/Footer/CustomisableFooter';
import { FooterWrapper } from '@rsa-digital/evo-shared-components/components/Footer/CustomisableFooter/styles';
import FooterCompliance from '@rsa-digital/evo-shared-components/components/Footer/FooterCompliance';
import { StyledGrid } from '@rsa-digital/evo-shared-components/components/Footer/FooterCompliance/styles';
import FooterNavBar from '@rsa-digital/evo-shared-components/components/Footer/FooterNavBar';
import mediaQuery from '@rsa-digital/evo-shared-components/helpers/mediaQuery';
import spacing from '@rsa-digital/evo-shared-components/helpers/spacing';
import { colors } from '@rsa-digital/evo-shared-components/theme/RSA/colors';
import styled from 'styled-components';

export const StyledFooter = styled(CustomisableFooter)`
  background-color: ${colors.neutral07};
  border-top: solid 1px ${colors.neutral06};

  > ${FooterWrapper} {
    > ${FooterCompliance}:has(> ${StyledGrid}) {
      margin-top: ${spacing(4)};
      padding-bottom: ${spacing(8)};
      padding-right: 0;
      ${mediaQuery.tabletLandscape`
        padding-right: 37vw;
        margin-top: ${spacing(8)};
      `}
    }

    > ${FooterNavBar} {
      padding-bottom: 0;
      padding-right: 0;
    }
  }
`;
